<div class="trace">
  <div class="trace__header">
    <lib-button variant="secondary" type="button" prefixIcon="ArrowLeft" (clicked)="goBack()">
      Volver
    </lib-button>
    <h2>
      Recorrido del archivo
      <span *ngIf="trace() as t" class="trace__id">· #{{ t.ingest_id }}</span>
    </h2>
    <span
      *ngIf="(trace()?.estado || recorrido()?.estado) as estado"
      class="badge"
      [ngClass]="badgeClass(estado)"
    >
      {{ estado }}
    </span>
  </div>

  <p *ngIf="loading()" class="trace__muted">Cargando trazabilidad…</p>
  <p *ngIf="error() as e" class="trace__error">{{ e }}</p>

  <ng-container *ngIf="!loading() && !error()">
    <!-- Tres partes de la preservación -->
    <section class="trace__section" *ngIf="recorrido() as r">
      <h3>Tres partes de la preservación</h3>
      <div class="trace__cards">
        <div class="card">
          <h4>Máster (AIP)</h4>
          <ng-container *ngIf="r.tres_partes.master as m; else sinCopia">
            <span class="badge" [ngClass]="badgeClass(m.last_status)">{{ m.last_status }}</span>
            <p class="trace__path">{{ m.path }}</p>
            <p class="trace__muted">Próxima verificación: {{ m.next_fixity_check_at | date: 'short' }}</p>
          </ng-container>
        </div>
        <div class="card">
          <h4>Consulta (DIP)</h4>
          <ng-container *ngIf="r.tres_partes.consulta as c; else sinCopia">
            <span class="badge" [ngClass]="badgeClass(c.last_status)">{{ c.last_status }}</span>
            <p class="trace__path">{{ c.path }}</p>
            <p class="trace__muted">Próxima verificación: {{ c.next_fixity_check_at | date: 'short' }}</p>
          </ng-container>
        </div>
        <div class="card">
          <h4>Actualización</h4>
          <p class="trace__muted">{{ r.tres_partes.actualizacion }}</p>
        </div>
      </div>
      <ng-template #sinCopia><p class="trace__muted">No registrada.</p></ng-template>
    </section>

    <!-- Timeline de pasos -->
    <section class="trace__section" *ngIf="recorrido()?.pasos?.length">
      <h3>Recorrido</h3>
      <ol class="timeline">
        <li *ngFor="let paso of recorrido()!.pasos" class="timeline__item">
          <span class="timeline__phase">{{ paso.fase }}</span>
          <div class="timeline__body">
            <p class="timeline__desc">{{ paso.descripcion }}</p>
            <span class="badge" [ngClass]="badgeClass(paso.outcome)">{{ paso.outcome }}</span>
            <span class="trace__muted" *ngIf="paso.momento"> · {{ paso.momento | date: 'short' }}</span>
          </div>
        </li>
      </ol>
    </section>

    <!-- Integridad y antivirus -->
    <section class="trace__section" *ngIf="trace() as t">
      <h3>Integridad y antivirus</h3>
      <div class="trace__cards">
        <div class="card">
          <h4>Fixity</h4>
          <span class="badge" [ngClass]="badgeClass(t.fixity.ok ? 'pass' : 'fail')">
            {{ t.fixity.ok ? 'OK' : 'REVISAR' }}
          </span>
          <p class="trace__muted">MD5 decl/calc:</p>
          <p class="trace__path">{{ t.fixity.md5_declarado }} / {{ t.fixity.md5_calculado }}</p>
        </div>
        <div class="card">
          <h4>Antivirus</h4>
          <span class="badge" [ngClass]="badgeClass((t.antivirus.acta_ok && t.antivirus.rescan_ok !== false) ? 'pass' : 'fail')">
            {{ t.antivirus.acta_ok ? 'Acta OK' : 'Acta REVISAR' }}
          </span>
          <p class="trace__muted">Re-escaneo: {{ t.antivirus.rescan_ok === null ? 'omitido' : (t.antivirus.rescan_ok ? 'limpio' : 'INFECTADO') }} · Infectados: {{ t.antivirus.infected ?? 0 }}</p>
        </div>
        <div class="card">
          <h4>Objetos</h4>
          <p class="trace__big">{{ t.total_objetos_iso ?? 0 }}</p>
          <p class="trace__muted">objetos extraídos del ISO</p>
        </div>
      </div>
    </section>

    <!-- Eventos PREMIS -->
    <section class="trace__section" *ngIf="trace()?.recorrido?.length">
      <h3>Eventos PREMIS</h3>
      <table class="trace__table">
        <thead>
          <tr><th>Evento</th><th>Resultado</th><th>Agente</th><th>Cuándo</th><th>Detalle</th></tr>
        </thead>
        <tbody>
          <tr *ngFor="let ev of trace()!.recorrido">
            <td>{{ ev.event_type }}</td>
            <td><span class="badge" [ngClass]="badgeClass(ev.outcome)">{{ ev.outcome }}</span></td>
            <td>{{ ev.agent }}</td>
            <td>{{ ev.occurred_at | date: 'short' }}</td>
            <td class="trace__detail">{{ ev.detail }}</td>
          </tr>
        </tbody>
      </table>
    </section>
  </ng-container>
</div>
